<template>
  <div class="private-domain-traffic-page">
    <private-domain-traffic :setting="setting" />
  </div>
</template>

<script>
import PrivateDomainTraffic from '@/components/privateDomainTraffic/index'
import privateDomainTrafficApi from '@/utils/http/modules/privateDomain/traffic.request'

export default {
  name: 'PrivateTrafficHome',
  components: { PrivateDomainTraffic },
  data() {
    return {
      setting: {},
    }
  },
  created() {
    this.getPrivateDomainTrafficData()
  },
  methods: {
    async getPrivateDomainTrafficData() {
      const params = {
        id: this.$route.query.id,
        zbid: zbvd.zbid,
      }
      const { dataObj } =
        await privateDomainTrafficApi.postSmsPrivateDomainTrafficDetail(params)
      if (dataObj) {
        this.setting = this.formatPrivateDomainTrafficData(dataObj)
      }
    },
    // 格式化短信推送接口数据，和其他引流设置字段保持一致
    formatPrivateDomainTrafficData(data) {
      const { describe, guideLanguage, membersUrl } = data
      data = {
        ...data,
        desc: describe,
        leadingWords: guideLanguage,
        qrCodeUrl: membersUrl,
      }
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.private-domain-traffic-page {
  box-sizing: border-box;
  height: 100vh;
  padding-top: 30px;
  background-image: url('https://static2.sinsam.com/zhibo/static/img/live/private-domain/traffic/page-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  ::v-deep .private-traffic__header {
    text-align: center;
  }
}
</style>
